import React, {useState} from "react";
import {Box, Toolbar} from "@mui/material";
import {RegistrationApiGet, useGetRegistrationQuery} from "./reg_api";
import RegList, {searchFields} from "./RegList";
import SnackError from "../../components/SnackError";
import {Route, Routes, useNavigate, useParams} from "react-router-dom";
import Title from "../navigation/Title";
import InitializeApp from "../../components/InitializeApp";
import {OpListController} from "../operation/Operations";
import {useGetOperationByIdQuery} from "../operation/operation_api";
import filterFunction from "../../libs/filterFunction";
import {SearchBox} from "../../components/SearchBox";


type ListProps = {}

export const OperRegs = ({}: ListProps) => {

    const {id} = useParams<"id">()
    const [filter, setFilter] = useState("")
    const {data: operation} = useGetOperationByIdQuery({id: parseInt(id || "0")})
    const {data, error, isFetching} = useGetRegistrationQuery({
        operation: parseInt(id || "0"),
        page: 0,
        pageSize: 999,
        active: true,
        sort: [{col: "StartTime", dir: "desc"}]
    })

    if (isFetching) {
        return <InitializeApp/>
    }
    if (error) {
        return <SnackError error={error}/>
    }

    const list: Array<RegistrationApiGet> = data && data.result.filter(filterFunction(filter, searchFields)) || [];

    return <>
        <Toolbar sx={{
            display: "flex",
            "&.MuiToolbar-root": {p: 0},
            mb: 1,
            justifyContent: "space-between",
            alignItems: "flex-end",
            flexWrap: "wrap"
        }}>
            <SearchBox value={filter} onChange={setFilter}/>
        </Toolbar>
        <Box
            sx={{display: "grid", mt: 2, gridTemplateColumns: "repeat(auto-fill, minmax(450px, 1fr))", gridGap: "1em"}}>
            <Title title={"Odprte prijave: " + (operation?.Name || "<nalagam>")}/>
            <RegList items={list}/>
        </Box>

    </>;
}


export default () => {

    const navigate = useNavigate();
    return <Routes>
        <Route path={"/"} element={<>
            <Title title={"Izberi operacijo"}/>
            <OpListController
                pageSize={100}
                selectable={true}
                onSelect={(id) => navigate("./" + id)}
            />
        </>}/>
        <Route path={"/:id"} element={<OperRegs/>}/>
    </Routes>
}
